import { useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { ShopModel } from '@merchant-clients/shop';

import { tApp } from '@frontend/locales';
import { usePersistentUiSettings } from '@frontend/utils';

import { FormikSelectField } from '../formik-select-field.component';

export interface AppDrawerShopSelectProps {
  options: ShopModel[];
}

export const AppDrawerShopSelectComponent = ({
  options,
}: AppDrawerShopSelectProps) => {
  const theme = useTheme();
  const { values } = useFormikContext<{
    shopId: string;
  }>();

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentRoute = pathname.split('/')[2];
  const { shopId } = useParams();
  const { ordersPage, updateOrdersPage, statsPage, updateStatsPage } =
    usePersistentUiSettings();

  const selectOptions = useMemo(() => {
    return options.map((shop) => ({
      id: shop.id.toString(),
      displayName: shop.name,
    }));
  }, [options]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: acts on a new selection only; re-running when the URL shop changes would navigate back to the form value
  useEffect(() => {
    if (shopId === values.shopId) {
      return;
    }

    navigate(`/${values.shopId}/${currentRoute}`);

    updateOrdersPage({
      filter: {
        ...ordersPage.filter,
        placeIds: undefined,
      },
    });

    // Places belong to a shop, so the stats places are reset as well.
    updateStatsPage({
      filter: {
        ...statsPage.filter,
        placeIds: undefined,
      },
    });
  }, [values.shopId]);

  return (
    <FormikSelectField
      name="shopId"
      label={tApp.drawer.siteUnit()}
      options={selectOptions}
      sx={{
        mt: theme.spacing(2),
        mb: theme.spacing(1),
      }}
    />
  );
};
